import {
    hexFromArgb,
    sourceColorFromImage,
} from '@material/material-color-utilities';
import { Avatar, AvatarProps } from '@mui/material';
import { stringToColor } from '@utils/colorUtils';
import { useRef, useState } from 'react';

interface AutoColorAvatarProps extends AvatarProps {
    value: string;
}

const AutoColorAvatar = ({
    src,
    value,
    sx = {},
    ...props
}: AutoColorAvatarProps) => {
    // const [imageColor, setImageColor] = useState();

    return (
        <Avatar
            src={src}
            sx={{
                bgcolor: !src ? stringToColor(value) : 'transparent',
                ...sx,
            }}
            {...props}
            slotProps={{
                img: {
                    crossOrigin: 'anonymous',
                    // onLoad: (e: Event) =>
                    //     sourceColorFromImage(e.currentTarget).then(color => {
                    //         setImageColor(hexFromArgb(color));
                    //     }),
                },
            }}
        >
            {value?.getNameInitials()}
        </Avatar>
    );
};

export default AutoColorAvatar;
